/*jshint esversion: 9 */
// import { mapGetters, mapActions } from 'vuex';
export const HomeMixin = {
  data: () => ({
    containers: [
      // Standard Vorlagen
      // {id: 0, widget: 'one', width: 1, height: 1, position: false, color: 'red'},
      // {id: 0, widget: 'two', width: 1, height: 0.5, position: false, color: 'blue'},
      // {id: 19, widget: 'two', width: 0.5, height: 1, position: false, color: 'blue'},
      // {id: 19, widget: 'three', width: 0.5, height: 0.5, position: false, color: 'green'},

      {id: 1, widget: 'logo', width: 1, height: 1, position: false, color: 'yellow'},
      {id: 2, widget: 'app', width: 1, height: 0.5, position: false, color: 'blue'},
      {id: 3, widget: 'register', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 4, widget: 'support', width: 0.5, height: 0.5, position: false, color: 'green'},
      // {id: 4, widget: 'text', width: 1, height: 1, position: false, color: 'red'},
      {id: 5, widget: 'algorithmicFlow', width: 1, height: 0.5, position: false, color: 'blue'},
      {id: 6, widget: 'social', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 7, widget: 'training', width: 1, height: 1, position: false, color: 'red'},
      {id: 26, widget: 'trainingVideo', width: 1, height: 0.5, position: false, color: 'red'},
      {id: 8, widget: 'workbench', width: 1, height: 0.5, position: false, color: 'blue'},
      {id: 10, widget: 'research', width: 0.5, height: 0.5, position: false, color: 'blue'},
      // {id: 9, widget: 'comingSoon', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 12, widget: 'taktPartners', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 15, widget: 'processBoards', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 18, widget: 'piktoOne', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 19, widget: 'piktoTwo', width: 0.5, height: 0.5, position: false, color: 'green'},
      {id: 20, widget: 'taktConnect', width: 0.5, height: 1, position: false, color: 'blue'},
      {id: 21, widget: 'knowledge', width: 0.5, height: 1, position: false, color: 'blue'},
      {id: 22, widget: 'taktPower', width: 0.5, height: 1, position: false, color: 'blue'},
      {id: 23, widget: 'textTwo', width: 1, height: 0.5, position: false, color: 'blue'},
      {id: 24, widget: 'career', width: 1, height: 1, position: false, color: 'yellow'},
      {id: 25, widget: 'takting', width: 1, height: 1, position: false, color: 'yellow'},
    ],
    min_res: 0.5,
  }),
  created() {
    this.setPosition();
  },
  computed: {
    columns() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return 1;
        case 'sm': return 2;
        case 'md': return 4;
        case 'lg': return 4;
        case 'xl': return 4;
      }
    }
  },
  watch: {
    '$vuetify.breakpoint.name'() {
      this.setPosition();
    },
  },
  methods: {
    setPosition() {
      this.containers.forEach(cont => {
        cont.position = false;
      });
      let array = [];
      for (let i = 0; i < 1/this.min_res; i++) {
        array.push([]);
        for (let j = 0; j < this.columns/this.min_res; j++) {
          array[i].push(0);
        }
      }
      //set fixed elements
      let fixed_container = this.containers.find(cont => cont.id === 1);
      //id: 1, position: center-top
      let fixed_row_index = 0;
      let fixed_col_index = (this.columns/this.min_res) / 2 - 1;
      for (let i = 0; i < fixed_container.height/this.min_res; i++) {
        for (let j = 0; j < fixed_container.width/this.min_res; j++) {
          array[fixed_row_index + i].splice(fixed_col_index + j, 1, fixed_container.id * -1);
        }
      }
      array[fixed_row_index].splice(fixed_col_index, 1, fixed_container.id);
      fixed_container.position = [fixed_col_index * this.min_res,fixed_row_index * this.min_res];
      //end fixed elements

      for (var row_index = 0; row_index < array.length; row_index++) {
        if (this.containers.findIndex(item => item.position === false) !== -1) {
          let row = array[row_index];
          for (var col_index = 0; col_index < row.length; col_index++) {
            this.shuffle(this.containers);
            //filter
            let containers_filtered = this.containers.filter(container => {
              let boolean = true;
              if (col_index + container.width/this.min_res > this.columns/this.min_res) {
                boolean = false;
              }
              for (let i = 0; i < container.height/this.min_res; i++) {
                for (let j = 0; j < container.width/this.min_res; j++) {
                  if (array[row_index + i][col_index + j] !== 0) {
                    boolean = false;
                  }
                }
              }
              return boolean;
            });
            if (containers_filtered.findIndex(item => item.position === false) !== -1) {
              let container = containers_filtered.find(item => item.position === false);
              container.position = [col_index * this.min_res, row_index * this.min_res];
              for (let i = 0; i < container.height/this.min_res; i++) {
                for (let j = 0; j < container.width/this.min_res; j++) {
                  array[row_index + i].splice(col_index + j, 1, container.id * -1);
                }
              }
              row.splice(col_index, 1, container.id);
            }
          }
          //if elements with no position still exist add rows
          if (this.containers.findIndex(item => item.position === false) !== -1) {
            for (let i = 0; i < (1/this.min_res)/2; i++) {
              array.push([]);
              for (let j = 0; j < this.columns/this.min_res; j++) {
                array[i + row_index + 2].push(0);
              }
            }
          }
        }
      }
    },
    shuffle(array) {
      var currentIndex = array.length, temporaryValue, randomIndex;

      // While there remain elements to shuffle...
      while (0 !== currentIndex) {

        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    }
  }
};
